import { createStore, useStore } from 'zustand';
import { FirstCategoryLevel } from 'src/api/types';
import { createContext, useContext } from 'react';

interface Props {
  multyLevelCategoriesList: FirstCategoryLevel[];
}
interface State extends Props {
  setMultyLevelCategoriesList: (
    multyLevelCategoriesList: FirstCategoryLevel[]
  ) => void;
}

type Store = ReturnType<typeof createSSRMultyLevelCategoriesStore>;

export const createSSRMultyLevelCategoriesStore = (initProps: Props) => {
  const defaultProps: Props = {
    multyLevelCategoriesList: []
  };
  return createStore<State>()((set) => ({
    ...defaultProps,
    ...initProps,
    setMultyLevelCategoriesList: (multyLevelCategoriesList) =>
      set({ multyLevelCategoriesList })
  }));
};

export const SSRMultyLevelCategoriesStoreContext = createContext<Store | null>(
  null
);

const useSSRMultyLevelCategoriesStore = () => {
  const store = useContext(SSRMultyLevelCategoriesStoreContext);

  const multyLevelCategoriesList = useStore(
    store,
    (s) => s.multyLevelCategoriesList
  );
  const setMultyLevelCategoriesList = useStore(
    store,
    (s) => s.setMultyLevelCategoriesList
  );

  return {
    multyLevelCategoriesList,
    setMultyLevelCategoriesList
  };
};

export default useSSRMultyLevelCategoriesStore;
